import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import ItemList from 'flarum/common/utils/ItemList';
import LinkButton from 'flarum/common/components/LinkButton';
import type Mithril from 'mithril';

export default function () {
  extend(IndexPage.prototype, 'sidebarItems', (items: ItemList<Mithril.Children>) => {
    if (app.forum.attribute('blomstra_powered_by_banner')) {
      // Disabled while we migrate from Blomstra to Flarum BV
      // items.add(
      //   'blomstra-powered-by',
      //   <LinkButton href="https://blomstra.net/powered-by" external={true} target="_blank"><></></LinkButton>
      // );
    }

    return items;
  });
}
